var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mb-2",
          staticStyle: { bottom: "1em", right: "1em" },
          attrs: { collapse: "", color: "deep-purple darken-1", dark: "" }
        },
        [_c("span", [_vm._v("Edit")])]
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Stock", value: _vm.stockId, disabled: "" }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Quantity" },
                model: {
                  value: _vm.quantity,
                  callback: function($$v) {
                    _vm.quantity = $$v
                  },
                  expression: "quantity"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-autocomplete", {
                attrs: { label: "Unit", items: _vm.units },
                model: {
                  value: _vm.unit,
                  callback: function($$v) {
                    _vm.unit = $$v
                  },
                  expression: "unit"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Price/Unit" },
                model: {
                  value: _vm.unitPrice,
                  callback: function($$v) {
                    _vm.unitPrice = $$v
                  },
                  expression: "unitPrice"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Discount" },
                model: {
                  value: _vm.discount,
                  callback: function($$v) {
                    _vm.discount = $$v
                  },
                  expression: "discount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Order Status",
                  value: _vm.orderDetailStatusId,
                  disabled: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Date Allocated", type: "date" },
                model: {
                  value: _vm.dateAllocated,
                  callback: function($$v) {
                    _vm.dateAllocated = $$v
                  },
                  expression: "dateAllocated"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            tile: "",
                            color: "success",
                            dark: ""
                          },
                          on: { click: _vm.updateDetail }
                        },
                        [_c("span", [_vm._v("Update")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            tile: "",
                            color: "blue-grey darken-1",
                            dark: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("close")
                            }
                          }
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }